import ConstrainBase from "../ConstrainBase";
import ValidationResult from "../ValidationResult";

/**
 * class BoolConstrain
 * Validiert Boolean-Werte analog zur serverseitigen BoolConstrain.php
 */
class BoolConstrain extends ConstrainBase {

  validate(value) {
    if (value === null || value === undefined) {
      return new ValidationResult(true, '');
    }
    const valid = [true, false, 'true', 'false', '1', '0', 1, 0];
    if (!valid.includes(value)) {
      return new ValidationResult(false, 'Bitte einen gültigen Boolean-Wert eingeben.');
    }
    return new ValidationResult(true, '');
  }
}

export default BoolConstrain;
